module.exports = __webpack_public_path__ + "img/p3.1bd5cd91.png";